import { gql } from '@apollo/client'

export const GET_MOBILE_CODE = gql`
  mutation getMobileCode(
    $areaCode: String = "+86"
    $behaviorParam: BehaviorVerifyParam
    $mobile: String!
    $scene: VerifyCodeScene = LOGIN_REGISTER
    $verifyType: MobileVerifyType = SMS
  ) {
    status: sendMobileVerifyCode(
      param: {
        areaCode: $areaCode
        mobile: $mobile
        scene: $scene
        behaviorParam: $behaviorParam
        verifyType: $verifyType
      }
    )
  }
`

export const LOGIN_BY_MOBILE = gql`
  mutation loginByMobile(
    $areaCode: String = "+86"
    $mobile: String!
    $code: String!
    $inviteCode: String
  ) {
    data: loginByMobile(
      param: {
        areaCode: $areaCode
        mobile: $mobile
        code: $code
        inviteCode: $inviteCode
      }
    ) {
      isNew
      token
      tokenVoucher
    }
  }
`

export const LOGIN_BY_MOBILE_PWD = gql`
  mutation loginByMobilePwd(
    $areaCode: String = "+86"
    $mobile: String!
    $password: String!
  ) {
    data: loginByMobilePwd(
      param: { areaCode: $areaCode, mobile: $mobile, password: $password }
    ) {
      token
      tokenVoucher
    }
  }
`

export const SET_PWD_BY_MOBILE = gql`
  mutation setPwdByMobile(
    $areaCode: String = "+86"
    $mobile: String!
    $code: String!
    $password: String!
  ) {
    status: changePwdByMobile(
      param: {
        areaCode: $areaCode
        mobile: $mobile
        code: $code
        newPwd: $password
      }
    )
  }
`

export const SET_TRADE_PWD = gql`
  mutation setTradePwd($password: String!, $code: String!) {
    status: setTradePassword(tradePassword: $password, verificationCode: $code)
  }
`

export const LOGOUT = gql`
  mutation logout {
    status: logout
  }
`

/* 扫码登陆 */
export const GET_LOGIN_SERIAL_NUMBER = gql`
  query getLoginSerialNumber {
    loginSerialNumber {
      serialNumber
    }
  }
`

// 轮询扫码登录结果
export const POLL_LOGIN_SERIAL_NUMBER_STATUS = gql`
  query pollLoginSerialNumberStatus($serialNumber: String!) {
    loginSerialNumberStatus(serialNumber: $serialNumber) {
      status
      token
      tokenVoucher
    }
  }
`

// 跨站登陆，用临时token交换正式token
export const EXCHANGE_TOKEN = gql`
  mutation exchangeToken($token: String!) {
    token: exchangeSessionToken(tokenVoucher: $token)
  }
`
